module.exports = __webpack_public_path__ + "img/kleisma2-m@2.109bb19c.jpg";